// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___3_ObF","container_1":"container_1___1vJlP","container_2":"container_2___3omxQ"};


//////////////////
// WEBPACK FOOTER
// ./src/views/News/styles.module.scss
// module id = 725
// module chunks = 0